import { showToast } from '../slices/uiSlice';

const errorMiddleware = (store) => (next) => (action) => {
  if (action.type.endsWith('/rejected')) {
    const errorMessage = action.payload || 'A apărut o eroare neașteptată';
    store.dispatch(showToast({
      message: errorMessage,
      type: 'error'
    }));
  }
  
  if (action.type.endsWith('/fulfilled') && action.type.includes('create')) {
    const entityType = action.type.split('/')[0];
    const messages = {
      clients: 'Client creat cu succes',
      services: 'Serviciu creat cu succes',
      contracts: 'Contract creat cu succes',
      templates: 'Șablon creat cu succes',
      cronJobs: 'Job programat cu succes',
    };
    
    if (messages[entityType]) {
      store.dispatch(showToast({
        message: messages[entityType],
        type: 'success'
      }));
    }
  }
  
  if (action.type.endsWith('/fulfilled') && action.type.includes('update')) {
    const entityType = action.type.split('/')[0];
    const messages = {
      clients: 'Client actualizat cu succes',
      services: 'Serviciu actualizat cu succes',
      contracts: 'Contract actualizat cu succes',
      templates: 'Șablon actualizat cu succes',
      cronJobs: 'Job actualizat cu succes',
    };
    
    if (messages[entityType]) {
      store.dispatch(showToast({
        message: messages[entityType],
        type: 'success'
      }));
    }
  }
  
  if (action.type.endsWith('/fulfilled') && action.type.includes('delete')) {
    const entityType = action.type.split('/')[0];
    const messages = {
      clients: 'Client șters cu succes',
      services: 'Serviciu șters cu succes',
      contracts: 'Contract șters cu succes',
      templates: 'Șablon șters cu succes',
      cronJobs: 'Job șters cu succes',
    };
    
    if (messages[entityType]) {
      store.dispatch(showToast({
        message: messages[entityType],
        type: 'success'
      }));
    }
  }
  
  return next(action);
};

export default errorMiddleware;